import { render } from "./PageNumber6.vue?vue&type=template&id=101c00b2&scoped=true"
import script from "./PageNumber6.vue?vue&type=script&lang=js"
export * from "./PageNumber6.vue?vue&type=script&lang=js"

import "./PageNumber6.vue?vue&type=style&index=0&id=101c00b2&scoped=true&lang=css"

import exportComponent from "/home/alex/Documents/EVO/investorpresentation/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101c00b2"]])

export default __exports__